export default function Hero() {
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="relative min-h-screen flex items-center overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-br from-[#1e293b] via-[#4c1d95] to-[#7c3aed]"></div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-black/10 to-black/20"></div>
      
      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 py-32">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <div className="text-left">
            <h1 className="text-6xl lg:text-7xl font-bold text-white leading-tight mb-8">
              Secure Your<br />
              Digital Life<br />
              With Confidence
            </h1>
            <p className="text-xl text-gray-200 mb-12 leading-relaxed max-w-xl">
              Experience ultimate online privacy and security with ESCRITORIO BENDER LTDA's advanced VPN technology. Protect your data, browse anonymously, and access content freely.
            </p>
            <div className="flex gap-4">
              <button
                onClick={() => scrollToSection('contact')}
                className="px-8 py-4 bg-purple-600 text-white text-base font-semibold rounded-lg hover:bg-purple-700 transition-all shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
              >
                Get Started
              </button>
              <button
                onClick={() => scrollToSection('vpn-service')}
                className="px-8 py-4 bg-transparent border-2 border-white text-white text-base font-semibold rounded-lg hover:bg-white/10 transition-all whitespace-nowrap cursor-pointer"
              >
                Learn More
              </button>
            </div>
          </div>

          <div className="flex justify-center items-center">
            <div className="relative w-full h-[500px] flex items-center justify-center">
              <div className="absolute inset-0 bg-gradient-to-br from-purple-500/20 to-blue-500/20 rounded-full blur-3xl"></div>
              <img 
                src="https://public.readdy.ai/ai/img_res/80781c9d5a5d91c4a81569dbc0e0b5f3.jpg"
                alt="VPN Security Shield"
                className="relative z-10 w-full h-full object-contain drop-shadow-2xl"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
